import { History } from "history";

import {
  CreateCityRequest,
  PaginateQuery,
  UpdateCityRequest,
  CityDto,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";

//#region Get Cities

export const GET_CITIES = "GET_CITIES";
export const GET_CITIES_SUCCESS: any = "GET_CITIES_SUCCESS";
export const GET_CITIES_ERROR: any = "GET_CITIES_ERROR";

export interface GetCitiesAction {
  type: typeof GET_CITIES;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetCitiesSuccessAction {
  type: typeof GET_CITIES_SUCCESS;
  payload: Paginated<CityDto>;
}

export interface GetCitiesErrorAction {
  type: typeof GET_CITIES_ERROR;
  payload: any;
}
//#endregion

//#region Get City

export const GET_CITY = "GET_CITY";
export const GET_CITY_SUCCESS: any = "GET_CITY_SUCCESS";
export const GET_CITY_ERROR: any = "GET_CITY_ERROR";

export interface GetCityAction {
  type: typeof GET_CITY;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetCitySuccessAction {
  type: typeof GET_CITY_SUCCESS;
  payload: CityDto;
}

export interface GetCityErrorAction {
  type: typeof GET_CITY_ERROR;
  payload: any;
}
//#endregion

//#region Get City Select List

export const GET_CITY_SELECT_LIST = "GET_CITY_SELECT_LIST";
export const GET_CITY_SELECT_LIST_SUCCESS: any = "GET_CITY_SELECT_LIST_SUCCESS";
export const GET_CITY_SELECT_LIST_ERROR: any = "GET_CITY_SELECT_LIST_ERROR";
export const RESET_CITY_SELECT_LIST: any = "RESET_CITY_SELECT_LIST";

export interface GetCitySelectListAction {
  type: typeof GET_CITY_SELECT_LIST;
  payload: {
    governorateId?: string;
    history: History;
  };
}

export interface GetCitySelectListSuccessAction {
  type: typeof GET_CITY_SELECT_LIST_SUCCESS;
  payload: SelectListDto[];
}

export interface GetCitySelectListErrorAction {
  type: typeof GET_CITY_SELECT_LIST_ERROR;
  payload: any;
}

export interface ResetCitySelectListAction {
  type: typeof RESET_CITY_SELECT_LIST;
  payload: any;
}

//#endregion

//#region Add City

export const ADD_CITY = "ADD_CITY";
export const ADD_CITY_SUCCESS: any = "ADD_CITY_SUCCESS";
export const ADD_CITY_ERROR: any = "ADD_CITY_ERROR";

export interface AddCityAction {
  type: typeof ADD_CITY;
  payload: {
    request: CreateCityRequest;
    history: History;
  };
}

export interface AddCitySuccessAction {
  type: typeof ADD_CITY_SUCCESS;
  payload: null;
}

export interface AddCityErrorAction {
  type: typeof ADD_CITY_ERROR;
  payload: any;
}
//#endregion

//#region Update City

export const UPDATE_CITY = "UPDATE_CITY";
export const UPDATE_CITY_SUCCESS: any = "UPDATE_CITY_SUCCESS";
export const UPDATE_CITY_ERROR: any = "UPDATE_CITY_ERROR";

export interface UpdateCityAction {
  type: typeof UPDATE_CITY;
  payload: {
    id: string;
    request: UpdateCityRequest;
    history: History;
  };
}

export interface UpdateCitySuccessAction {
  type: typeof UPDATE_CITY_SUCCESS;
  payload: null;
}

export interface UpdateCityErrorAction {
  type: typeof UPDATE_CITY_ERROR;
  payload: any;
}
//#endregion

//#region Delete City

export const DELETE_CITY_CONSENT: any = "DELETE_CITY_CONSENT";
export const DELETE_CITY = "DELETE_CITY";
export const DELETE_CITY_SUCCESS: any = "DELETE_CITY_SUCCESS";
export const DELETE_CITY_ERROR: any = "DELETE_CITY_ERROR";

export interface DeleteCityConsentAction {
  type: typeof DELETE_CITY_CONSENT;
  payload: string;
}

export interface DeleteCityAction {
  type: typeof DELETE_CITY;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteCitySuccessAction {
  type: typeof DELETE_CITY_SUCCESS;
  payload: null;
}

export interface DeleteCityErrorAction {
  type: typeof DELETE_CITY_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetCitiesAction
  | GetCitiesSuccessAction
  | GetCitiesErrorAction
  | GetCityAction
  | GetCitySuccessAction
  | GetCityErrorAction
  | GetCitySelectListAction
  | GetCitySelectListSuccessAction
  | GetCitySelectListErrorAction
  | AddCityAction
  | AddCitySuccessAction
  | AddCityErrorAction
  | UpdateCityAction
  | UpdateCitySuccessAction
  | UpdateCityErrorAction
  | DeleteCityConsentAction
  | DeleteCityAction
  | DeleteCitySuccessAction
  | DeleteCityErrorAction;
